import React from 'react'
import styles from './style/index.module.less'
import useScreenDesign from '@/Core/utils/hooks/useScreenDesign'

const ProgressBar = ({ progress = '50'}) => {
    const isMobile = useScreenDesign();
    
    let p = progress;
    if(p.includes(',')){
      p = p.replace(',','.')
    }
    
    const progressNum = Number(p);
    
    // Calculate right position based on progress value
    const getProgressNumRight = (progressValue: number) => {
      if (progressValue <= 7) {
        return '-40px';
      }
      if (progressValue >= 90) {
        return '-6px';
      }
      return '-10px';
    };

    return (
        <div className={styles.myProgress}>
        <div 
          className={styles.progressBarDiv}
          style={{ 
            '--progress-width': `${progressNum}%`
          } as React.CSSProperties}
        >
          <div 
            className={styles.progressNum}
            style={{
              '--progress-num-right': getProgressNumRight(progressNum)
            } as React.CSSProperties}
          >{`${progress}%`}</div>
        </div>
      </div>
    )
}


export default ProgressBar